"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = voiceCode;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    error: '',
    is_send_voice_code: false,
    timerRepeat: 30,
    currentTime: 0,
    preloader: false
};

function voiceCode() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {

        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
            return (0, _extends3.default)({}, state, {
                error: action.error.message,
                is_send_voice_code: false,
                preloader: false
            });
        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_REQUEST:
            return (0, _extends3.default)({}, state, {
                is_send_voice_code: false,
                preloader: true
            });
        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_RESET:
            return (0, _extends3.default)({}, state, {
                error: ''
            });
        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_SUCCESS:
            return (0, _extends3.default)({}, state, {
                is_send_voice_code: action.result.sendingStatus,
                timerRepeat: action.result.timeToRepeat,
                currentTime: action.result.timeToRepeat,
                error: '',
                preloader: false
            });
        case _constants.VoiceCodeConstants.SET_TIMER:
            return (0, _extends3.default)({}, state, {
                currentTime: action.time
            });

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/voice_code.js
// module id = 1917
// module chunks = 0